webpackJsonp([1],{

/***/ "+u60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fb_js__ = __webpack_require__("t3kZ");




// const brandPrimary = '#20a8d8'
var brandSuccess = '#4dbd74';
var brandInfo = '#63c2de';
var brandDanger = '#f86c6b';

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['chartData'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* mixins */].reactiveProp],
  mounted: function mounted() {
    var elements = 27;
    // this.data1 = Array(27).fill(0)
    var data2 = [];
    var data3 = [];
    // console.log('data1', data1)
    this.renderChart(this.chartData, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            stepSize: Math.ceil(10 / 5),
            max: 10
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    });
  }
});

/***/ }),

/***/ "+xNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'writeQuestion',
  data: function data() {
    return {
      question: ''
    };
  },
  methods: {
    onClick: function onClick() {
      console.log(this.question);
      this.$store.commit('setQuestion', this.question);
      this.$router.push({
        name: 'privacy'
      });
    }
  }
});

/***/ }),

/***/ "/Yp7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1dfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h3',{attrs:{"id":"login"}},[_vm._v("로그인")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"아이디:","label-for":"exampleInput1"}},[_c('b-form-input',{attrs:{"id":"exampleInput1","state":_vm.isValidName,"type":"text","required":"","placeholder":"아이디를 입력해주세요"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("로그인")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.$router.push({name: 'Join'})}}},[_vm._v("회원가입")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1rGg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Q0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__("eOfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea6ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__("iKdl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea6ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3HqO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__("hTsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__("F2Jc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__("z+0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__("xd+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__("TnYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__("3ye0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__("nZtp");
/* unused harmony reexport Aside */
/* unused harmony reexport Breadcrumb */
/* unused harmony reexport Callout */
/* unused harmony reexport Footer */
/* unused harmony reexport Header */
/* unused harmony reexport Sidebar */
/* unused harmony reexport Switch */










/***/ }),

/***/ "3Rj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['numbers'],
  mounted: function mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: ['연애', '직장', '친구', '가족', '그 외'],
      datasets: [{
        label: '사람들과 유사도',
        backgroundColor: '#f87979',
        data: this.numbers
      }]
    });
  }
});

/***/ }),

/***/ "3ye0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("Uoa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcde9422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("N868");
function injectStyle (ssrContext) {
  __webpack_require__("66bP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcde9422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "416X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"bg-variant":"white","text-variant":"#416e79"}},[_c('h4',{staticClass:"title"},[_c('router-link',{attrs:{"to":{name: 'postAnswer', params: { imgID: _vm.question['.key'] }}}},[_vm._v(_vm._s(_vm.question.question))])],1),_vm._v(" "),_c('h6',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.categoryKey[_vm.question.category]))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4VMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{attrs:{"id":"prompt"}},[_vm._v("질문이 등록되었습니다. 답변은 "),_c('router-link',{attrs:{"to":{name: 'answerView', params: {imgID: _vm.imgID }}}},[_vm._v("여기")]),_vm._v("에서 확인해주세요. 카카오톡으로 보내드린 링크에서도 확인하실 수 있습니다.")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5+fc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5V0N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5hDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__("oyMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077bcbde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__("9UvK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077bcbde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "66bP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6WzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"divCanvas"}},[(_vm.canvasLoaded)?_c('canvas',{directives:[{name:"canvas-added",rawName:"v-canvas-added",value:({paths: _vm.paths, img: _vm.img}),expression:"{paths: paths, img: img}"}],ref:"talkCanvas",attrs:{"id":"talkCanvas"},on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd,"touchcancel":_vm.onTouchCancel}}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-view',{on:{"refreshCanvas":_vm.onRefreshCanvas,"postFinished":_vm.onPostFinished}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6vGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineExample_vue__ = __webpack_require__("CN0b");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7UuX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__("yxEI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),

/***/ "8AJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "986l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("답변을 기다리는 질문")]),_vm._v(" "),_c('h6',[_vm._v("질문을 누르시면 답변을 달아주실 수 있습니다.")]),_vm._v(" "),_vm._l((_vm.unansweredQuestions),function(q){return _c('question',{key:q['.key'],attrs:{"question":q}})}),_vm._v(" "),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://pf.kakao.com/_gqVmxl","target":"_blank"}},[_c('img',{attrs:{"src":"static/kakaotalk.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9UvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ob3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostAnswer_vue__ = __webpack_require__("gVcF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637032d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostAnswer_vue__ = __webpack_require__("cfa0");
function injectStyle (ssrContext) {
  __webpack_require__("fVkz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-637032d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637032d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A+6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),

/***/ "AMk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postQuestion',
  props: ['imgID'],
  firebase: {
    questions: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('questions')
  },
  directives: {
    canvasAdded: function canvasAdded(el, binding) {
      var context = el.getContext("2d");
      var img = new Image();
      img.addEventListener("load", function () {
        // console.log(img)
        // el.width = img.naturalWidth
        el.height = el.width * img.naturalHeight / img.naturalWidth;
        // const xOffset = el.width * 0.1
        context.drawImage(img, 0, 0, el.width, el.height);
        binding.value.paths.forEach(function (path) {
          context.strokeStyle = path.color;
          context.lineWidth = path.width;
          context.stroke(path.path);
        });
      }, false);
      img.src = binding.value.img;
    }
  },
  computed: {
    img: function img() {
      var _this = this;

      if (this.questions.length === 0) {
        return '';
      }
      var img = this.questions.find(function (question) {
        // console.log(question['.key'])
        return question['.key'] === _this.imgID;
      });
      // console.log(img)
      return img.img;
    },
    color: function color() {
      if (this.$route.name === 'privacy') {
        return 'black';
      } else if (this.$route.name === 'annotate') {
        return 'red';
      }
    },
    width: function width() {
      if (this.$route.name === 'privacy') {
        return 8;
      } else if (this.$route.name === 'annotate') {
        return 2;
      }
    },
    isPathAvailable: function isPathAvailable() {
      return this.$route.name === 'privacy' || this.$route.name === 'annotate';
    }
  },
  data: function data() {
    return {
      touches: [],
      paths: [],
      canvasLoaded: true
    };
  },
  methods: {
    onPostFinished: function onPostFinished() {
      console.log("post finished");

      var img = this.$refs.talkCanvas.toDataURL();

      var question = {
        category: this.$store.state.category,
        question: this.$store.state.question,
        imgEdited: img,
        img: this.img,
        answers: 0
      };

      var updates = {};
      updates[this.imgID] = question;
      console.log(question);
      this.$root.$firebaseRefs.questions.update(updates);
    },
    onRefreshCanvas: function onRefreshCanvas() {
      this.paths.pop();
    },
    onTouchStart: function onTouchStart(ev) {
      if (this.isPathAvailable) {
        ev.preventDefault();
        var context = ev.target.getContext('2d');
        var canvasX = ev.target.offsetLeft;
        var canvasY = ev.target.offsetTop;
        console.log(ev.target.offsetLeft);
        for (var i = 0; i < ev.touches.length; i++) {
          console.log(ev.touches);
          var touch = ev.touches[i];
          var newPath = new Path2D();
          newPath.moveTo(touch.pageX - canvasX, touch.pageY - canvasY);
          this.touches.push({
            identifier: touch.identifier,
            path: newPath
          });
        }
      }
    },
    onTouchMove: function onTouchMove(ev) {
      var _this2 = this;

      if (this.isPathAvailable) {
        ev.preventDefault();
        var context = ev.target.getContext('2d');
        var canvasX = ev.target.offsetLeft;
        var canvasY = ev.target.offsetTop;

        var _loop = function _loop(i) {
          var newTouch = ev.changedTouches[i];
          var oldTouchIdx = _this2.touches.findIndex(function (touch) {
            return touch.identifier === newTouch.identifier;
          });
          var oldTouch = _this2.touches[oldTouchIdx];
          oldTouch.path.lineTo(newTouch.pageX - canvasX, newTouch.pageY - canvasY);
        };

        for (var i = 0; i < ev.changedTouches.length; i++) {
          _loop(i);
        }
        this.touches.forEach(function (val) {
          context.strokeStyle = _this2.color;
          context.lineWidth = _this2.width;
          context.stroke(val.path);
        });
      }
    },
    onTouchEnd: function onTouchEnd(ev) {
      var _this3 = this;

      if (this.isPathAvailable) {
        ev.preventDefault();
        var context = ev.target.getContext('2d');
        var canvasX = ev.target.offsetLeft;
        var canvasY = ev.target.offsetTop;

        var _loop2 = function _loop2(i) {
          var newTouch = ev.changedTouches[i];
          var oldTouchIdx = _this3.touches.findIndex(function (touch) {
            return touch.identifier === newTouch.identifier;
          });
          var oldTouch = _this3.touches[oldTouchIdx];
          oldTouch.path.lineTo(newTouch.pageX - canvasX, newTouch.pageY - canvasY);
          _this3.paths.push({
            path: oldTouch.path,
            color: _this3.color,
            width: _this3.width
          });
          _this3.touches.splice(oldTouchIdx, 1);
        };

        for (var i = 0; i < ev.changedTouches.length; i++) {
          _loop2(i);
        }
      }
    },
    onTouchCancel: function onTouchCancel(ev) {
      if (this.isPathAvailable) {
        for (var i = 0; i < ev.changedTouches.length; i++) {
          var oldTouchIdx = this.touches.findIndex(function (touch) {
            return touch.identifier === newTouch.identifier;
          });
          this.touches.splice(oldTouchIdx, 1);
        }
      }
    }
  }
});

/***/ }),

/***/ "AfaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__("Fzo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb34f1d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__("p5cx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb34f1d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CLZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("위 대화 내용에 관해 무엇이 궁금하신가요?")]),_vm._v(" "),_c('h6',[_vm._v("예/아니오로 대답할 수 있는 질문을 적어주세요.")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"질문을 적어주세요."},model:{value:(_vm.question),callback:function ($$v) {_vm.question=$$v},expression:"question"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{on:{"click":_vm.onClick}},[_vm._v("다음")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CN0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        label: 'Data One',
        backgroundColor: '#f87979',
        data: [40, 39, 10, 40, 39, 80, 40]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "CeOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CfkK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("ckY2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21062c24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("f7wt");
function injectStyle (ssrContext) {
  __webpack_require__("1rGg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21062c24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D54m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D6bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionList_vue__ = __webpack_require__("Y5SG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7c2de3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionList_vue__ = __webpack_require__("986l");
function injectStyle (ssrContext) {
  __webpack_require__("oW+7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d7c2de3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7c2de3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ejc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"type":"light","variant":"info","position:":"","fixed":""}},[_c('b-navbar-nav',[_c('b-nav-item',{on:{"click":function($event){_vm.$router.go(-1)}}},[_c('i',{staticClass:"fa fa-long-arrow-left",attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('b-navbar-nav',[_c('b-nav-item',{on:{"click":function($event){_vm.$router.push({name:'questionList'})}}},[_vm._v("질문 보기")])],1),_vm._v(" "),_c('b-navbar-nav',[_c('b-nav-item',{on:{"click":function($event){_vm.$router.push({name: 'dashboard'})}}},[_vm._v(_vm._s(_vm.name))])],1)],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('router-view',{on:{"questionsChecked":_vm.onQuestionsChecked}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F2Jc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__("HQag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfd8af1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__("aUO+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfd8af1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Fzo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ "GEdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")]),_vm._v(" © 2017 creativeLabs.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GmNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__("maV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513b182c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__("Let7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513b182c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gwq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "answerComplete"
});

/***/ }),

/***/ "HJuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"<i class='icon-list'></i>"}},[_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Today")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"warning"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Meeting with "),_c('strong',[_vm._v("Lucas")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"info"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Skype with "),_c('strong',[_vm._v("Megan")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 5pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-social-skype"}),_vm._v("  On-line ")])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Tomorrow")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"danger"}},[_c('div',[_vm._v("New UI Project - "),_c('strong',[_vm._v("deadline")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  10 - 11pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"success"}},[_c('div',[_c('strong',[_vm._v("#10 Startups.Garden")]),_vm._v(" Meetup")]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"primary"}},[_c('div',[_c('strong',[_vm._v("Team meeting")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 6pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/8.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-speech'></i>"}},[_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-settings'></i>"}},[_c('div',{staticClass:"p-3"},[_c('h6',[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-4"},[_c('small',[_c('b',[_vm._v("Option 1")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 2")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 3")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 4")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("System Utilization")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-4"},[_c('small',[_c('b',[_vm._v("CPU Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"variant":"info","value":25}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("348 Processes. 1/4 Cores.")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("Memory Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"variant":"warning","value":70}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("11444GB/16384MB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 1 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"variant":"danger","value":95}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("243GB/256GB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 2 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"variant":"success","value":10}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("25GB/256GB")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HQag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),

/***/ "JH9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* mixins */].reactiveProp],
  props: ['chartData'],
  mounted: function mounted() {
    // console.log(this.numbers)
    this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "Jeve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K88H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // interest: [],
      age: [],
      form: {
        name: '',
        interest: [],
        age: null,
        gender: null,
        pushSubscribed: false,
        selected: [],
        pushToken: ''
      }

      // isValidName: null
    };
  },

  computed: {
    isValidName: function isValidName() {
      var _this = this;

      if (this.form.name.length < 4) {
        return null;
      }
      var idx = this.$root.users.findIndex(function (element) {
        return element.name === _this.form.name;
      });
      return idx === -1;
    },
    isPushAvailable: function isPushAvailable() {
      return 'serviceWorker' in navigator && 'PushManager' in window;
    }
  },
  methods: {
    onSubmit: function onSubmit(evt) {
      this.$root.$firebaseRefs.users.push(this.form);
      this.$store.commit('setAnswererInfo', this.form);
      document.cookie = "username=" + this.form.name + ";";

      this.$router.push('questionList');
    },

    registerNotification: function registerNotification() {
      var _this2 = this;

      // alert('adsf')
      __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].messaging.requestPermission().then(function () {
        console.log('Notification permission granted.');
        navigator.serviceWorker.register('/static/sw.js').then(function (registration) {
          __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].messaging.useServiceWorker(registration);
          __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].messaging.getToken().then(function (currentToken) {
            if (currentToken) {
              console.log(currentToken);
              _this2.form.pushToken = currentToken;
              _this2.form.pushSubscribed = true;
            } else {
              // Show permission request.
              console.log('No Instance ID token available. Request permission to generate one.');
              // Show permission UI.
              alert('No Instance ID token available. Request permission to generate one.');
            }
          }).catch(function (err) {
            console.log(err);
            alert('알림 구독에 실패했습니다. 다시 시도해주세요.');
          });
        });
      }).catch(function (err) {
        console.log('Unable to get permission to notify.', err);
        alert('Unable to get permission to notify.', err);
      });
    }
  }
});

/***/ }),

/***/ "L7tD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postFinished',
  computed: {
    imgID: function imgID() {
      return this.$route.params.imgID;
    }
  }
});

/***/ }),

/***/ "L9t8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieExample_vue__ = __webpack_require__("JH9y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Let7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a11caf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ejc2");
function injectStyle (ssrContext) {
  __webpack_require__("qva5")
  __webpack_require__("tG7D")
  __webpack_require__("5V0N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a11caf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MJqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("위 대화에서, 속뜻이 궁금한 말풍선에 손가락으로 동그라미를 그려주세요.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.$emit('refreshCanvas')}}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{attrs:{"to":{name:'writeQuestion'}}},[_vm._v("다음")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MaPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__ = __webpack_require__("+u60");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N868":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__("Jeve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fb_js__ = __webpack_require__("t3kZ");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_9__fb_js__["a" /* default */].messaging.onMessage(function (payload) {
  console.log("Message received. ", payload);
  alert('새 질문이 도착했습니다. 상단 바의 "질문 보기"에서 확인해주세요.');
  // this.navbarText = '새 질문이 도착했습니다.'
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  firebase: {
    questions: __WEBPACK_IMPORTED_MODULE_9__fb_js__["a" /* default */].db.ref('questions'),
    users: __WEBPACK_IMPORTED_MODULE_9__fb_js__["a" /* default */].db.ref('users')
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Nl40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O6AL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PDOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newAnswerView',
  props: ['imgID'],
  firebase: function firebase() {
    return {
      answers: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('answers').orderByChild('questionID').equalTo(this.imgID), // answers specific to the question ID
      questions: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('questions').orderByKey().equalTo(this.imgID) // find specific question
    };
  },
  // DB-TODO: Show answers
  computed: {
    question: function question() {
      var _this = this;

      if (this.questions) {
        var q = this.questions.find(function (q) {
          return q['.key'] === _this.imgID;
        });
        if (q) return q.question;else return '';
      } else {
        return '';
      }
    },
    proportion: function proportion() {
      var totalAnswersCount = this.answers.length;
      console.log(this.answers.length);
      var totalYesCount = this.answers.reduce(function (prevValue, curElement) {
        return prevValue + (curElement.isYes ? 1 : 0);
      }, 0);
      return Math.round(totalYesCount / totalAnswersCount * 100 || 0) + '%(' + totalAnswersCount + '명 중 ' + totalYesCount + ' 명)';
    },
    comments: function comments() {
      if (this.answers) {
        return this.answers.map(function (a) {
          return { answer: a.answer, isYes: a.isYes };
        });
      } else {
        return [];
      }
    },
    imgSrc: function imgSrc() {
      if (this.questions.length === 0) {
        return null;
      } else {
        return this.questions[0].imgEdited;
      }
    }
  }
});

/***/ }),

/***/ "QeGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),

/***/ "QzxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Account")])]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-bell-o"}),_vm._v(" Updates"),_c('b-badge',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" Messages"),_c('b-badge',{attrs:{"variant":"success"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-tasks"}),_vm._v(" Tasks"),_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-comments"}),_vm._v(" Comments"),_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Settings")])]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profile")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Settings")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-usd"}),_vm._v(" Payments"),_c('b-badge',{attrs:{"variant":"default"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-file"}),_vm._v(" Projects"),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" Lock Account")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3PU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',[_c('b-button',{attrs:{"to":{name:'dashboard'}}},[_vm._v("나의 현황 보기")]),_vm._v(" "),_c('b-button',{attrs:{"to":{name:'questionList'}}},[_vm._v("다른 질문 보기")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin"},[_c('span',[_vm._v("답변이 완료되었습니다.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),

/***/ "RBFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewQuestion_vue__ = __webpack_require__("fi/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6eb2ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewQuestion_vue__ = __webpack_require__("ScwB");
function injectStyle (ssrContext) {
  __webpack_require__("U6Js")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewQuestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6eb2ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewQuestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RRem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),

/***/ "RTz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),

/***/ "SJG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',{attrs:{"bg-variant":"light","header":"눈치백단"}},[_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('p',[_vm._v("\n      “눈치백단”은 채팅 중, 속 뜻이 이해가 되지 않는 부분을 사람들에게 물어볼 수 있는 서비스입니다.\n      어떤 질문이 올라오는 지 보고 싶으시다면, 제대로 찾아오셨습니다. 로그인을 해주세요.\n      질문을 남기시려면 카카오톡 플러스친구에서 \"눈치백단\"을 찾아주세요. \n    ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.$router.push({name: 'Login'})}}},[_vm._v("로그인")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.$router.push({name: 'Join'})}}},[_vm._v("회원가입")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ScwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"bg-variant":"white","text-variant":"#416e79"}},[_c('h4',{staticClass:"title"},[_c('router-link',{attrs:{"to":{name: 'newAnswerView', params: { imgID: _vm.question['.key'] }}}},[_vm._v(_vm._s(_vm.question.question))])],1),_vm._v(" "),_c('h6',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.categoryKey[_vm.question.category]))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T808":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TUjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TnYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("7UuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40b6a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("TpYu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40b6a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "TpYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-nav',{staticClass:"d-md-down-none",attrs:{"is-nav-bar":""}},[_c('b-nav-item',{staticClass:"px-3"},[_vm._v("Dashboard")]),_vm._v(" "),_c('b-nav-item',{staticClass:"px-3"},[_vm._v("Users")]),_vm._v(" "),_c('b-nav-item',{staticClass:"px-3"},[_vm._v("Settings")])],1),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[_c('b-nav-item',{staticClass:"d-md-down-none"},[_c('i',{staticClass:"icon-bell"}),_vm._v(" "),_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v("5")])],1),_vm._v(" "),_c('b-nav-item',{staticClass:"d-md-down-none"},[_c('i',{staticClass:"icon-list"})]),_vm._v(" "),_c('b-nav-item',{staticClass:"d-md-down-none"},[_c('i',{staticClass:"icon-location-pin"})]),_vm._v(" "),_c('HeaderDropdown')],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U6Js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UULP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"answerimg"}},[_c('img',{attrs:{"src":_vm.imgSrc}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"text"}},[_c('h5',[_vm._v(_vm._s(_vm.question))]),_vm._v(" "),_c('br'),_vm._v("\n    남겨주신 이 질문에 대해\n    "),_c('span',{attrs:{"id":"proportion"}},[_vm._v(_vm._s(_vm.proportion))]),_vm._v("의 사람들이\n    "),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"answer"}},[_vm._v("그렇다")]),_vm._v("라고 대답했습니다.\n  ")]),_vm._v(" "),_c('div',[_vm._v("\n    이 질문과 관련해 추가로 다음과 같은 의견을 남겼습니다.\n    "),_c('ul',_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.answer},[_c('span',{class:comment.isYes ?'yes':'no'},[_vm._v(_vm._s(comment.isYes ? '그렇다' : '아니다'))]),_vm._v(" - "+_vm._s(comment.answer))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uoa4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__("fP7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__("GmNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__("b7GE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__("ZXJu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__("5hDe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__("AfaC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__("2Q0N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__("ie5f");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ "VXs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Woqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_PieExample__ = __webpack_require__("L9t8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_BarExample__ = __webpack_require__("ZO1y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_LineExample__ = __webpack_require__("6vGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_MainChartExample__ = __webpack_require__("MaPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewQuestion__ = __webpack_require__("RBFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coreui__ = __webpack_require__("3HqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// DB-TODO: Connect with ranking system









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  components: {
    LineExample: __WEBPACK_IMPORTED_MODULE_2__charts_LineExample__["a" /* default */],
    PieExample: __WEBPACK_IMPORTED_MODULE_0__charts_PieExample__["a" /* default */],
    BarExample: __WEBPACK_IMPORTED_MODULE_1__charts_BarExample__["a" /* default */],
    MainChartExample: __WEBPACK_IMPORTED_MODULE_3__dashboard_MainChartExample__["a" /* default */],
    NewQuestion: __WEBPACK_IMPORTED_MODULE_4__components_NewQuestion__["a" /* default */]
  },
  firebase: {
    questions: __WEBPACK_IMPORTED_MODULE_6__fb_js__["a" /* default */].db.ref("questions"),
    answers: __WEBPACK_IMPORTED_MODULE_6__fb_js__["a" /* default */].db.ref("answers"),
    users: __WEBPACK_IMPORTED_MODULE_6__fb_js__["a" /* default */].db.ref("users")
  },
  computed: {
    userInfo: function userInfo() {
      var _this = this;

      console.log(this.name);
      if (this.users) {
        var userInfo = this.users.find(function (user) {
          return user.name === _this.name;
        });
        return userInfo;
      } else {
        return null;
      }
    },
    answeredQuestions: function answeredQuestions() {
      var _this2 = this;

      if (this.questions && this.userInfo && this.userInfo.questions) {
        return this.questions.filter(function (q) {
          return _this2.userInfo.questions.includes(q['.key']);
        });
      } else {
        return [];
      }
    },
    userAnswers: function userAnswers() {
      var _this3 = this;

      // console.log("ddd")
      // console.log(this.userInfo)
      // console.log('name', this.name)
      var answers = [];
      if (this.userInfo && this.userInfo.questions) {
        return this.answers.filter(function (a) {
          return _this3.userInfo.questions.includes(a.questionID) && a.name === _this3.userInfo.name;
        });
        // for(let q in this.userInfo.questions){
        //   console.log('userAnswers', this.userInfo.questions[q])
        //   let answer = this.answers.find(answer => {
        //     console.log(this.name)
        //     return (answer.name === this.name && answer.questionID === this.userInfo.questions[q])
        //   })
        //   console.log(this.answers)
        //   console.log('userAnswers', answer)
        //   answers.push(answer)
        // }      
        // return answers
      } else {
        return [];
      }
    },
    totalCorrect: function totalCorrect() {
      var _this4 = this;

      var accurate = 0;
      if (this.myTotalCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop = function _loop(a) {
          var question = _this4.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this4.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this4.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers) {
          var ycount;
          var ncount;
          var i;

          _loop(a);
        }
        console.log(this.myTotalCount);
        return Math.round(accurate / this.myTotalCount * 100);
      } else {
        return 0;
      }
    },
    loveCorrect: function loveCorrect() {
      var _this5 = this;

      var accurate = 0;
      if (this.myLoveCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop2 = function _loop2(a) {
          var question = _this5.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this5.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this5.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers.filter(function (a) {
          return a.category === 'love';
        })) {
          var ycount;
          var ncount;
          var i;

          _loop2(a);
        }
        console.log(this.myTotalCount);
        return accurate / this.myLoveCount * 100;
      } else {
        return 0;
      }
    },
    familyCorrect: function familyCorrect() {
      var _this6 = this;

      var accurate = 0;
      if (this.myFamliyCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop3 = function _loop3(a) {
          var question = _this6.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this6.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this6.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers.filter(function (a) {
          return a.category === 'family';
        })) {
          var ycount;
          var ncount;
          var i;

          _loop3(a);
        }
        console.log(this.myTotalCount);
        return accurate / this.myFamilyCount * 100;
      } else {
        return 0;
      }
    },
    businessCorrect: function businessCorrect() {
      var _this7 = this;

      var accurate = 0;
      if (this.myBusinessCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop4 = function _loop4(a) {
          var question = _this7.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this7.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this7.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers.filter(function (a) {
          return a.category === 'business';
        })) {
          var ycount;
          var ncount;
          var i;

          _loop4(a);
        }
        console.log(this.myTotalCount);
        return accurate / this.myBusinessCount * 100;
      } else {
        return 0;
      }
    },
    friendCorrect: function friendCorrect() {
      var _this8 = this;

      var accurate = 0;
      if (this.myFriendCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop5 = function _loop5(a) {
          var question = _this8.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this8.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this8.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers.filter(function (a) {
          return a.category === 'friend';
        })) {
          var ycount;
          var ncount;
          var i;

          _loop5(a);
        }
        console.log(this.myTotalCount);
        return accurate / this.myFriendCount * 100;
      } else {
        return 0;
      }
    },
    etcCorrect: function etcCorrect() {
      var _this9 = this;

      var accurate = 0;
      if (this.myEtcCount === 0) {
        return 0;
      }
      if (this.userAnswers.length !== 0) {
        var _loop6 = function _loop6(a) {
          var question = _this9.questions.find(function (question) {
            // console.log('totalcorrect', this.userAnswers)
            // console.log('totalcorrect', this.userAnswers[a])
            return question[".key"] === _this9.userAnswers[a].questionID;
          });
          var answers = question.answers;
          ycount = 0;
          ncount = 0;

          for (i = 0; i < answers.length; i++) {
            if (answers[i] === true) {
              ycount++;
            } else {
              ncount++;
            }
          }
          var majority = ycount >= ncount ? true : false;
          if (_this9.userAnswers[a].isYes == majority) {
            accurate++;
          }
        };

        for (var a in this.userAnswers.filter(function (a) {
          return a.category === 'etc';
        })) {
          var ycount;
          var ncount;
          var i;

          _loop6(a);
        }
        console.log(this.myTotalCount);
        return accurate / this.myEtcCount * 100;
      } else {
        return 0;
      }
    },
    myTotalCount: function myTotalCount() {
      var _this10 = this;

      return this.answers.filter(function (a) {
        return a.name === _this10.$store.state.answererInfo.name;
      }).length;
    },
    myLoveCount: function myLoveCount() {
      var _this11 = this;

      return this.answers.filter(function (a) {
        return a.name === _this11.$store.state.answererInfo.name && a.category === 'love';
      }).length;
    },
    myBusinessCount: function myBusinessCount() {
      var _this12 = this;

      return this.answers.filter(function (a) {
        return a.name === _this12.$store.state.answererInfo.name && a.category === 'business';
      }).length;
    },
    myFriendCount: function myFriendCount() {
      var _this13 = this;

      return this.answers.filter(function (a) {
        return a.name === _this13.$store.state.answererInfo.name && a.category === 'friend';
      }).length;
    },
    myFamilyCount: function myFamilyCount() {
      var _this14 = this;

      return this.answers.filter(function (a) {
        return a.name === _this14.$store.state.answererInfo.name && a.category === 'family';
      }).length;
    },
    myEtcCount: function myEtcCount() {
      var _this15 = this;

      return this.answers.filter(function (a) {
        return a.name === _this15.$store.state.answererInfo.name && a.category === 'etc';
      }).length;
    },
    loveCount: function loveCount() {
      return this.answers.filter(function (a) {
        return a.category === 'love';
      }).length;
    },
    businessCount: function businessCount() {
      return this.answers.filter(function (a) {
        return a.category === 'business';
      }).length;
    },
    friendCount: function friendCount() {
      return this.answers.filter(function (a) {
        return a.category === 'friend';
      }).length;
    },
    familyCount: function familyCount() {
      return this.answers.filter(function (a) {
        return a.category === 'family';
      }).length;
    },
    etcCount: function etcCount() {
      return this.answers.filter(function (a) {
        return a.category === 'etc';
      }).length;
    },
    name: function name() {
      return this.$store.state.answererInfo.name;
    },
    pieChartData: function pieChartData() {
      return {
        labels: ['연애', '직장', '친구', '가족', '그 외'],
        datasets: [{
          backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16', '#E46651'],
          data: [this.myLoveCount, this.myBusinessCount, this.myFriendCount, this.myFamilyCount, this.myEtcCount]
        }]
      };
    },
    mainChartData: function mainChartData() {
      function convertHex(hex, opacity) {
        hex = hex.replace('#', '');
        var r = parseInt(hex.substring(0, 2), 16);
        var g = parseInt(hex.substring(2, 4), 16);
        var b = parseInt(hex.substring(4, 6), 16);

        var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
        return result;
      }
      var d = Array(27).fill(0);
      var timebase = 1511654400000;
      // console.log(this.userAnswers)
      if (this.userAnswers) {
        for (var i = 0; i < this.userAnswers.length; i++) {
          d[(Date.parse(this.userAnswers[i].date) - timebase) / 86400000]++;
        }
      }
      return {
        labels: ['S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S'],
        datasets: [{
          label: 'My Answer',
          backgroundColor: convertHex('#63c2de', 10),
          borderColor: '#63c2de',
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: d
        }]
      };
    }
  },
  created: function created() {
    var _this16 = this;

    console.log(document.cookie);
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)username\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (!this.$store.state.answererInfo.name && !cookieValue) {
      alert("Please Log-in");
      console.log("dddd");
      this.$router.push({ path: '/Login' });
    } else if (!this.$store.state.answererInfo.name) {
      this.name = cookieValue;
      this.$root.$firebaseRefs.users.once('value').then(function (snapshot) {
        var users = snapshot.val();
        console.log(users);
        for (var user in users) {
          console.log(user);
          if (users[user].name === _this16.name) {
            console.log(_this16.name);
            _this16.$store.commit('setAnswererInfo', users[user]);
          }
        }
      });
    }
  },


  methods: {
    imgFile: function imgFile(cat, num) {
      var category = '';
      var curCount = 0;
      var number = 0;
      var fileStr = 'static/badges/';
      switch (cat) {
        case 1:
          category = 'love';
          curCount = this.myLoveCount;
          break;
        case 2:
          category = 'business';
          curCount = this.myBusinessCount;
          break;
        case 3:
          category = 'family';
          curCount = this.myFamilyCount;
          break;
        case 4:
          category = 'friend';
          curCount = this.myFriendCount;
          break;
        case 5:
          category = 'etc';
          curCount = this.myEtcCount;
          break;
      }
      switch (num) {
        case 1:
          fileStr += category + '10';
          return curCount < 10 ? fileStr + '_de.png' : fileStr + '.png';
        case 2:
          fileStr += category + '30';
          return curCount < 30 ? fileStr + '_de.png' : fileStr + '.png';
        case 3:
          fileStr += category + '70';
          return curCount < 70 ? fileStr + '_de.png' : fileStr + '.png';
        case 4:
          fileStr += category;
          return curCount < 100 ? fileStr + 'M_de.png' : fileStr + 'M_C.png';

      }
    }
  }
});

/***/ }),

/***/ "XB9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'answerView',
  props: ['imgID'],
  firebase: function firebase() {
    return {
      answers: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('answers').orderByChild('questionID').equalTo(this.imgID), // answers specific to the question ID
      questions: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('questions').orderByKey().equalTo(this.imgID) // find specific question
    };
  },
  // DB-TODO: Show answers
  computed: {
    question: function question() {
      var _this = this;

      if (this.questions) {
        var q = this.questions.find(function (q) {
          return q['.key'] === _this.imgID;
        });
        if (q) return q.question;else return '';
      } else {
        return '';
      }
    },
    proportion: function proportion() {
      var totalAnswersCount = this.answers.length;
      console.log(this.answers.length);
      var totalYesCount = this.answers.reduce(function (prevValue, curElement) {
        return prevValue + (curElement.isYes ? 1 : 0);
      }, 0);
      return Math.round(totalYesCount / totalAnswersCount * 100 || 0) + '%(' + totalAnswersCount + '명 중 ' + totalYesCount + ' 명)';
    },
    comments: function comments() {
      if (this.answers) {
        return this.answers.map(function (a) {
          return { answer: a.answer, isYes: a.isYes };
        });
      } else {
        return [];
      }
    },
    imgSrc: function imgSrc() {
      if (this.questions.length === 0) {
        return null;
      } else {
        return this.questions[0].img;
      }
    }
  }
});

/***/ }),

/***/ "XQyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: ''
    };
  },
  firebase: {
    users: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('users')
  },
  created: function created() {
    var _this = this;

    console.log(document.cookie);
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)username\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (!this.$store.state.answererInfo.name && cookieValue) {
      this.name = cookieValue;
      this.$root.$firebaseRefs.users.once('value').then(function (snapshot) {
        var users = snapshot.val();
        console.log(users);
        for (var user in users) {
          console.log(user);
          if (users[user].name === _this.name) {
            console.log(_this.name);
            _this.$store.commit('setAnswererInfo', users[user]);
            _this.$router.push({ name: 'questionList' });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "Y5SG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Question_vue__ = __webpack_require__("d5Sz");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    question: __WEBPACK_IMPORTED_MODULE_1__components_Question_vue__["a" /* default */]
  },
  firebase: function firebase() {
    return {
      questions: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('questions'),
      users: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('users').orderByChild('name')
    };
  },

  computed: {
    user: function user() {
      var _this = this;

      return this.users.find(function (u) {
        return u.name === _this.$store.state.answererInfo.name;
      });
    },
    // answeredQuestions: function () {
    //   if(this.users && this.users.length !== 0) {
    //     return this.users[0].questions
    //   } else {
    //     return []
    //   }
    // },
    unansweredQuestions: function unansweredQuestions() {
      var _this2 = this;

      if (this.questions && this.user && this.user.questions && this.questions.length !== 0) {
        return this.questions.filter(function (q) {
          return q.question && !_this2.user.questions.includes(q['.key']);
        }).sort(function (a, b) {
          if (a.answers === 0) {
            return -1;
          } else if (b.answers === 0) {
            return 1;
          } else {
            return b.answers.length - a.answers.length;
          }
        });
      } else if (this.user && !this.user.questions) {
        return this.questions.filter(function (q) {
          return q.question;
        });
      } else {
        return [];
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.$emit('questionsChecked');
    console.log(document.cookie);
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)username\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (!this.$store.state.answererInfo.name && !cookieValue) {
      alert("Please Log-in");
      console.log("dddd");
      this.$router.push({ path: '/Login' });
    } else if (!this.$store.state.answererInfo.name) {
      this.name = cookieValue;
      this.$root.$firebaseRefs.users.once('value').then(function (snapshot) {
        var users = snapshot.val();
        console.log(users);
        for (var user in users) {
          console.log(user);
          if (users[user].name === _this3.name) {
            console.log(_this3.name);
            _this3.$store.commit('setAnswererInfo', users[user]);
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Join__ = __webpack_require__("cjnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Gate__ = __webpack_require__("Z/L8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_QuestionList__ = __webpack_require__("D6bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PostQuestion_PostQuestion__ = __webpack_require__("e8FL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PostQuestion_Annotate__ = __webpack_require__("xQZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PostQuestion_WriteQuestion__ = __webpack_require__("iXm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PostQuestion_Privacy__ = __webpack_require__("CfkK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PostQuestion_Categorize__ = __webpack_require__("bJqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PostAnswer_PostAnswer__ = __webpack_require__("9ob3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PostQuestion_PostFinished__ = __webpack_require__("au9y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AnswerView__ = __webpack_require__("xjyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PostAnswer_AnswerComplete__ = __webpack_require__("pkPA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Stats__ = __webpack_require__("dY3R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_NewAnswerView__ = __webpack_require__("ifzn");


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Gate',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Gate__["a" /* default */]
  }, {
    path: '/join',
    name: 'Join',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Join__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
  }, {
    path: '/questionList',
    name: 'questionList',
    component: __WEBPACK_IMPORTED_MODULE_5__components_QuestionList__["a" /* default */]
  }, {
    path: '/:imgID/postQuestion',
    name: 'postQuestion',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PostQuestion_PostQuestion__["a" /* default */],
    props: true,
    children: [{
      path: 'privacy',
      component: __WEBPACK_IMPORTED_MODULE_9__components_PostQuestion_Privacy__["a" /* default */],
      name: 'privacy'
    }, {
      path: 'writeQuestion',
      component: __WEBPACK_IMPORTED_MODULE_8__components_PostQuestion_WriteQuestion__["a" /* default */],
      name: 'writeQuestion'
    }, {
      path: 'annotate',
      component: __WEBPACK_IMPORTED_MODULE_7__components_PostQuestion_Annotate__["a" /* default */],
      name: 'annotate'
    }, {
      path: 'postFinished',
      name: 'postFinished',
      component: __WEBPACK_IMPORTED_MODULE_12__components_PostQuestion_PostFinished__["a" /* default */]
    }, {
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_10__components_PostQuestion_Categorize__["a" /* default */],
      name: 'categorize'
    }]
  }, {
    path: '/:imgID/postAnswer',
    name: 'postAnswer',
    component: __WEBPACK_IMPORTED_MODULE_11__components_PostAnswer_PostAnswer__["a" /* default */],
    props: true
  }, {
    path: '/:imgID/answerView',
    name: 'answerView',
    component: __WEBPACK_IMPORTED_MODULE_13__components_AnswerView__["a" /* default */],
    props: true
  }, {
    path: '/:imgID/newAnswerView',
    name: 'newAnswerView',
    component: __WEBPACK_IMPORTED_MODULE_16__components_NewAnswerView__["a" /* default */],
    props: true
  }, {
    path: '/answerComplete',
    name: 'answerComplete',
    component: __WEBPACK_IMPORTED_MODULE_14__components_PostAnswer_AnswerComplete__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Stats__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YkWf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/L8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gate_vue__ = __webpack_require__("XQyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7d1ece_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gate_vue__ = __webpack_require__("SJG5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f7d1ece_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZO1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarExample_vue__ = __webpack_require__("3Rj0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZXJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__("R3oz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c663a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__("Nl40");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c663a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aUO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "amIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown',
  data: function data() {
    return { itemsCount: 42 };
  }
});

/***/ }),

/***/ "au9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostFinished_vue__ = __webpack_require__("L7tD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29228e38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostFinished_vue__ = __webpack_require__("4VMy");
function injectStyle (ssrContext) {
  __webpack_require__("sGww")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29228e38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostFinished_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29228e38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostFinished_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7GE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__("RTz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbc610d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__("CeOV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbc610d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bJLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ "bJqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categorize_vue__ = __webpack_require__("hE0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438ac41f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categorize_vue__ = __webpack_require__("iV0f");
function injectStyle (ssrContext) {
  __webpack_require__("c7ja")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categorize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438ac41f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categorize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c7ja":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfa0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"answerimg"}},[_c('img',{attrs:{"src":_vm.question.imgEdited}})]),_c('br'),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.question.question))])]),_vm._v(" "),_c('div',[_c('b-button-group',[_c('b-button',{attrs:{"pressed":_vm.yActive,"variant":"primary"},on:{"update:pressed":function($event){_vm.yActive=$event},"click":_vm.onYActive}},[_vm._v("네")]),_vm._v(" "),_c('b-button',{attrs:{"pressed":_vm.nActive,"variant":"primary"},on:{"update:pressed":function($event){_vm.nActive=$event},"click":_vm.onNActive}},[_vm._v("아니오")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"추가로 하실 말씀이 있다면 적어주세요."},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('b-button',{on:{"click":function($event){_vm.onSubmit()}}},[_vm._v("완료")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cjnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__ = __webpack_require__("K88H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c55982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__ = __webpack_require__("pzi4");
function injectStyle (ssrContext) {
  __webpack_require__("rIUE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02c55982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c55982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ckY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy',
  methods: {
    onClick: function onClick() {
      if (this.isConfirmed === 'accepted') {
        this.$emit('postFinished');
        this.$router.push('postFinished');
      } else {
        this.showAlert = true;
      }
    }
  },
  data: function data() {
    return {
      isConfirmed: false,
      showAlert: false
    };
  }
});

/***/ }),

/***/ "d5Sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__("eE7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a71874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__("416X");
function injectStyle (ssrContext) {
  __webpack_require__("8AJT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a71874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dY3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("Woqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a07223_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("oUta");
function injectStyle (ssrContext) {
  __webpack_require__("YkWf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a07223_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e8FL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostQuestion_vue__ = __webpack_require__("AMk8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3272fd5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostQuestion_vue__ = __webpack_require__("6WzY");
function injectStyle (ssrContext) {
  __webpack_require__("fWnY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3272fd5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostQuestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3272fd5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostQuestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eE7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'question',
  props: ['question'],
  computed: {
    categoryKey: function categoryKey() {
      return {
        'friend': '친구',
        'business': '직장',
        'love': '연애',
        'family': '가족',
        'etc': '그 외'
      };
    }
  }

});

/***/ }),

/***/ "eOfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ "f7wt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("대화 내용 중 이름이나 연락처, 민감한 개인 정보를 손가락으로 칠해주세요.")]),_vm._v(" "),_c('div',[_c('b-form-checkbox',{attrs:{"id":"privacy","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.isConfirmed),callback:function ($$v) {_vm.isConfirmed=$$v},expression:"isConfirmed"}},[_vm._v("\r\n      민감한 개인 정보가 없는지 확인하셨나요?\r\n    ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-alert',{attrs:{"variant":"warning","show":_vm.showAlert}},[_vm._v("민감한 개인 정보가 없는지 확인해주세요.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.$emit('refreshCanvas')}}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{on:{"click":function($event){_vm.onClick()}}},[_vm._v("다음")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fP7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__("fSXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db898fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__("O6AL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db898fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fSXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),

/***/ "fVkz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fWnY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fi/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newQuestion',
  props: ['question'],
  computed: {
    categoryKey: function categoryKey() {
      return {
        'friend': '친구',
        'business': '직장',
        'love': '연애',
        'family': '가족',
        'etc': '그 외'
      };
    }
  }

});

/***/ }),

/***/ "gU3M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gVcF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "postAnswer",
  props: ['imgID'],
  data: function data() {
    return {
      Toggle1: false,
      Toggle2: false,
      yActive: false,
      nActive: false,
      answer: ''
    };
  },
  firebase: {
    questions: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('questions'),
    answers: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('answers'),
    users: __WEBPACK_IMPORTED_MODULE_0__fb_js__["a" /* default */].db.ref('users')
  },
  computed: {
    question: function question() {
      var _this = this;

      if (this.questions.length === 0) {
        return "";
      }
      var question = this.questions.find(function (question) {
        console.log(question['.key']);
        return question['.key'] === _this.imgID;
      });
      console.log(this.imgID);
      console.log(question);
      return question;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log(document.cookie);
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)username\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (!this.$store.state.answererInfo.name && !cookieValue) {
      alert("Please Log-in");
      console.log("dddd");
      this.$router.push({ path: '/Login' });
    } else if (!this.$store.state.answererInfo.name) {
      this.name = cookieValue;
      this.$root.$firebaseRefs.users.once('value').then(function (snapshot) {
        var users = snapshot.val();
        console.log(users);
        for (var user in users) {
          console.log(user);
          if (users[user].name === _this2.name) {
            _this2.$store.commit('setAnswererInfo', users[user]);
          }
        }
      });
    }
  },


  methods: {
    onYActive: function onYActive() {
      this.yActive = true;
      this.nActive = false;
    },
    onNActive: function onNActive() {
      this.nActive = true;
      this.yActive = false;
    },
    onSubmit: function onSubmit() {
      var date = new Date().toISOString().slice(0, 10);

      var answerObj = {
        isYes: this.yActive,
        answer: this.answer,
        name: this.$store.state.answererInfo.name,
        questionID: this.imgID,
        date: date,
        category: this.question.category
      };
      console.log(date);
      this.$firebaseRefs.answers.push(answerObj);
      var newAnswer = [answerObj.isYes];
      this.$firebaseRefs.questions.child(this.imgID).on('value', function (snapshot) {
        if (snapshot.val().answers != 0) {
          newAnswer = newAnswer.concat(snapshot.val().answers);
        }
      });
      var userInfo = this.users.find(function (user) {
        return user.name === answerObj.name;
      });
      console.log(userInfo);
      var userUpdates;
      if (userInfo.questions) {
        userInfo.questions.push(this.imgID);
        userUpdates = { questions: userInfo.questions };
      } else {
        userUpdates = { questions: [this.imgID] };
      }
      var updates = {};
      updates[this.imgID + "/answers"] = newAnswer;
      this.$root.$firebaseRefs.questions.update(updates);

      //console.log(this.users['-KzrBieCBvao_qb8XhGe'].questions)
      this.$firebaseRefs.users.child(userInfo[".key"]).update(userUpdates);
      this.$router.push({ path: '/answerComplete' });
    }
  }
});

/***/ }),

/***/ "hE0l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'categorize',
  methods: {
    onClick: function onClick(category) {
      this.$store.commit('setCategory', category);
      this.$router.push({
        name: 'annotate'
      });
    }
  }
});

/***/ }),

/***/ "hTsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__("oLVj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf19b78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__("HJuT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf19b78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "iKdl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iV0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',[_c('b-button-group',[_c('b-button',{staticClass:"ui button",on:{"click":function($event){_vm.onClick('love')}}},[_vm._v("연애")]),_vm._v(" "),_c('b-button',{staticClass:"ui button",on:{"click":function($event){_vm.onClick('friend')}}},[_vm._v("친구")]),_vm._v(" "),_c('b-button',{staticClass:"ui button",on:{"click":function($event){_vm.onClick('business')}}},[_vm._v("직장")]),_vm._v(" "),_c('b-button',{staticClass:"ui button",on:{"click":function($event){_vm.onClick('family')}}},[_vm._v("가족")]),_vm._v(" "),_c('b-button',{staticClass:"ui button",on:{"click":function($event){_vm.onClick('etc')}}},[_vm._v("그 외")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_vm._v("어떤 관계에서의 대화인지 선택해주세요."),_c('br'),_vm._v("\n  더 좋은 답변을 드리는 데 도움이 됩니다.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iXm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteQuestion_vue__ = __webpack_require__("+xNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70554c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteQuestion_vue__ = __webpack_require__("CLZ8");
function injectStyle (ssrContext) {
  __webpack_require__("5+fc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteQuestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70554c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteQuestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ie5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__("bJLv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c163f17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__("gU3M");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c163f17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ifzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAnswerView_vue__ = __webpack_require__("PDOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2ccd28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAnswerView_vue__ = __webpack_require__("UULP");
function injectStyle (ssrContext) {
  __webpack_require__("VXs4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f2ccd28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAnswerView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2ccd28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAnswerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l+HN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.0.2","C:\\Users\\khw\\Dropbox\\Documents\\Crowdsourcing\\webapp"]],"_from":"vue-chartjs@3.0.2","_id":"vue-chartjs@3.0.2","_inBundle":false,"_integrity":"sha512-m6ItjL8o3ff4JpbF083RzZ4KPiNBFsqMKmWCcAtlisOdm1vvB/9mUDJePmxYKJkvl2AcpvLPiH1cUrhq46r8vA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.0.2","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.0.2","saveSpec":null,"fetchSpec":"3.0.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz","_spec":"3.0.2","_where":"C:\\Users\\khw\\Dropbox\\Documents\\Crowdsourcing\\webapp","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.0.2"}

/***/ }),

/***/ "maV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),

/***/ "mllI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logIn',
  data: function data() {
    return {
      name: '',
      isValidName: null
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      document.cookie = "username=" + this.name + ";";
      this.$root.$firebaseRefs.users.once('value').then(function (snapshot) {
        var users = snapshot.val();
        console.log(users);
        for (var user in users) {
          console.log(user);
          if (users[user].name === _this.name) {
            _this.$store.commit('setAnswererInfo', users[user]);
            _this.$router.push({ path: '/questionsList' });
          }
        }
        _this.isValidName = false;
      });
    }
  }
});

/***/ }),

/***/ "nZtp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("RRem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc7ddf40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("TUjI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc7ddf40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oLVj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__("z+0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__("nZtp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */]
  }
});

/***/ }),

/***/ "oUta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h3',[_vm._v("내 답변 현황")]),_vm._v(" "),_c('vue-tabs',[_c('v-tab',{attrs:{"title":"답변 분석"}},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-6"},[_c('b-card',{staticClass:"bg-warning",attrs:{"no-body":true}},[_c('div',{staticClass:"card-body pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v("\n                  "+_vm._s(_vm.totalCorrect)+"%\n                  ")]),_vm._v(" "),_c('p',[_vm._v("당신과 같은 의견을 가진 사람의 비율")])])])],1)]),_vm._v(" "),_c('b-card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("답변 수")]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("from 26th November 2017 ")])])]),_vm._v(" "),_c('main-chart-example',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chartData":_vm.mainChartData}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box facebook"},[_c('p',[_c('br'),_vm._v("전체")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myTotalCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.answers.length))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box facebook"},[_c('p',[_c('br'),_vm._v("연애")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myLoveCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.loveCount))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box twitter"},[_c('p',[_c('br'),_vm._v("직장")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myBusinessCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.businessCount))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box linkedin"},[_c('p',[_c('br'),_vm._v("친구")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myFriendCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.friendCount))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box google-plus"},[_c('p',[_c('br'),_vm._v("가족")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myFamilyCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.familyCount))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"social-box google-plus"},[_c('p',[_c('br'),_vm._v("그 외")]),_vm._v(" "),_c('div',{attrs:{"width":"234"}}),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.myEtcCount))]),_vm._v(" "),_c('span',[_vm._v("내 답변 수")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.etcCount))]),_vm._v(" "),_c('span',[_vm._v("누적 답변")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',{attrs:{"header":"답변 유사도"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-4"},[_c('ul',{staticClass:"horizontal-bars"},[_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        연애: "+_vm._s(Math.round(_vm.loveCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.loveCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        직장: "+_vm._s(Math.round(_vm.businessCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.businessCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        친구: "+_vm._s(Math.round(_vm.friendCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.friendCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        가족: "+_vm._s(Math.round(_vm.familyCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.familyCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        그 외: "+_vm._s(Math.round(_vm.etcCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.etcCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n                        평균: "+_vm._s(Math.round(_vm.totalCorrect))+"%\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"value":_vm.totalCorrect,"variant":"info"}})],1)]),_vm._v(" "),_c('li',{staticClass:"legend"},[_c('b-badge',{attrs:{"pill":"","variant":"info"}}),_vm._v(" "),_c('small',[_vm._v("다수와 일치")])],1)])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-columns cols-2"},[_c('b-card',{attrs:{"header":"카테고리별 누적 답변"}},[_c('div',{staticClass:"chart-wrapper"},[_c('pie-example',{staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chartData":_vm.pieChartData}})],1)]),_vm._v(" "),_c('b-card',{attrs:{"header":"내 도전 과제"}},_vm._l((5),function(cat){return _c('b-row',{key:cat,attrs:{"no-gutters":""}},_vm._l((4),function(num){return _c('b-col',{key:num,attrs:{"cols":"3"}},[_c('img',{staticClass:"badges",attrs:{"src":_vm.imgFile(cat, num)}})])}))}))],1)],1)]),_vm._v(" "),_c('v-tab',{attrs:{"title":"답한 질문"}},_vm._l((_vm.answeredQuestions),function(question){return _c('new-question',{key:question['.key'],attrs:{"question":question}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oW+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oyMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ "p5cx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pkPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerComplete_vue__ = __webpack_require__("Gwq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5d77c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerComplete_vue__ = __webpack_require__("R3PU");
function injectStyle (ssrContext) {
  __webpack_require__("mllI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a5d77c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5d77c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pzi4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h3',{attrs:{"id":"registration"}},[_vm._v("회원가입")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"아이디:","label-for":"exampleInput1","description":"아이디는 본인 식별 용도로만 사용됩니다."}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","state":"isValidName","required":"","placeholder":"네 자 이상의 아이디를 입력해주세요"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),(_vm.isValidName === false)?_c('span',[_vm._v("이미 존재하는 아이디입니다.")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("관심 카테고리:\r\n    "),_c('b-form-checkbox-group',{attrs:{"id":"checkboxes1","name":"interest"},model:{value:(_vm.form.interest),callback:function ($$v) {_vm.$set(_vm.form, "interest", $$v)},expression:"form.interest"}},[_c('b-form-checkbox',{attrs:{"value":"love"}},[_vm._v("연애")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"friend"}},[_vm._v("친구")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"business"}},[_vm._v("직장")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"family"}},[_vm._v("가족")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"etc"}},[_vm._v("그 외")])],1),_vm._v(" "),(_vm.isPushAvailable && !_vm.form.pushSubscribed)?_c('b-button',{on:{"click":_vm.registerNotification}},[_vm._v("\r\n      관심 질문에 대한 알림을 받으시려면 여기를 눌러주세요.\r\n    ")]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_vm._v("성별:\r\n    "),_c('b-form-radio-group',{attrs:{"id":"radio1","name":"gender"},model:{value:(_vm.form.gender),callback:function ($$v) {_vm.$set(_vm.form, "gender", $$v)},expression:"form.gender"}},[_c('b-form-radio',{attrs:{"value":"man"}},[_vm._v("남")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"woman"}},[_vm._v("여")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"etc"}},[_vm._v("기타")])],1),_vm._v(" "),_c('br'),_vm._v("연령대:\r\n    "),_c('b-form-radio-group',{attrs:{"id":"radio2","label":"checkboxes2","name":"age"},model:{value:(_vm.form.age),callback:function ($$v) {_vm.$set(_vm.form, "age", $$v)},expression:"form.age"}},[_c('b-form-radio',{attrs:{"value":"10"}},[_vm._v("10대")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"20"}},[_vm._v("20대")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"30"}},[_vm._v("30대")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"40"}},[_vm._v("40대")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"50"}},[_vm._v("50대 이상")])],1),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("제출")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","variant":"secondary"}},[_vm._v("되돌리기")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qva5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIUE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6NF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"answerimg"}},[_c('img',{attrs:{"src":_vm.imgSrc}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"text"}},[_c('h5',[_vm._v(_vm._s(_vm.question))]),_vm._v(" "),_c('br'),_vm._v("\n    남겨주신 이 질문에 대해\n    "),_c('span',{attrs:{"id":"proportion"}},[_vm._v(_vm._s(_vm.proportion))]),_vm._v("의 사람들이\n    "),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"answer"}},[_vm._v("그렇다")]),_vm._v("라고 대답했습니다.\n  ")]),_vm._v(" "),_c('div',[_vm._v("\n    이 질문과 관련해 추가로 다음과 같은 의견을 남겼습니다.\n    "),_c('ul',_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.answer},[_c('span',{class:comment.isYes ?'yes':'no'},[_vm._v(_vm._s(comment.isYes ? '그렇다' : '아니다'))]),_vm._v(" - "+_vm._s(comment.answer))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sGww":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3kZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: "AIzaSyBiQONa7RRjXDxC-vzncpDk1xAwoJVVgfc",
  authDomain: "crowdsourcing-664f1.firebaseapp.com",
  databaseURL: "https://crowdsourcing-664f1.firebaseio.com",
  projectId: "crowdsourcing-664f1",
  storageBucket: "crowdsourcing-664f1.appspot.com",
  messagingSenderId: "1050847021579"
};

var fb = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* harmony default export */ __webpack_exports__["a"] = ({
  db: fb.database(),
  messaging: fb.messaging()
});

/***/ }),

/***/ "tG7D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wbvT":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    category: '',
    question: '',
    answererInfo: {}
  },
  mutations: {
    setCategory: function setCategory(state, payload) {
      state.category = payload;
    },
    setQuestion: function setQuestion(state, payload) {
      state.question = payload;
    },
    setAnswererInfo: function setAnswererInfo(state, payload) {
      state.answererInfo = payload;
    }
  }
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_js__ = __webpack_require__("t3kZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  // mounted() {

  // },
  computed: {
    name: function name() {
      return this.$store.state.answererInfo.name;
    }
  },
  data: function data() {
    return {
      navbarText: '질문 보기'
    };
  },
  methods: {
    onQuestionsChecked: function onQuestionsChecked() {
      this.navbarText = '질문 보기';
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c65ff3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("1dfT");
function injectStyle (ssrContext) {
  __webpack_require__("/Yp7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c65ff3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c65ff3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xQZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotate_vue__ = __webpack_require__("wbvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df61443e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Annotate_vue__ = __webpack_require__("MJqk");
function injectStyle (ssrContext) {
  __webpack_require__("D54m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotate_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df61443e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Annotate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xd+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("A+6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8604550a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("GEdi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8604550a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "xjyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerView_vue__ = __webpack_require__("XB9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d368d5c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerView_vue__ = __webpack_require__("s6NF");
function injectStyle (ssrContext) {
  __webpack_require__("l+HN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d368d5c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d368d5c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yxEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__("amIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7411e154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__("QzxD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7411e154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z+0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__("QeGN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50c68ebf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__("T808");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50c68ebf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.821209bd98245e590075.js